import { AxiosResponse } from 'axios';
import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  getBankListApi,
  getUserDetailsApi,
  createClaim,
  updateClaim,
  finishClaimById,
  getUserFranchiseByCodeApi,
  deleteFile,
} from 'services/openClaimService';
import { STATUS_OBJ } from 'utils/statusEnum';
import { getClaimById } from 'services/claimsService';
import { ApiResponse } from 'types/ApiResponse';
import { SagasAction } from 'types/SagasAction';
import { FilesCallback } from 'components/UploadInput';
import { appSelect } from 'store/appSelect';
import { ApplicationState } from 'store/store.inteface';
import {
  OPENCLAIM_TYPES,
  OpenClaimState,
  FileUploaded,
  ResponseFilesUploaded,
} from './types';
import { INITIAL_STATE } from './index';
import {
  setBankList,
  setUserData,
  setDraftId,
  setErrorDraft,
  setSuccessDraft,
  setCurrentStep,
  setUnlockedSteps,
  setRecoverDraft,
  setStatus,
  setFinalId,
  setStepsArray,
  setFranchiseByCode,
  setUploadFileAction,
  setDeleteFileAction,
} from './actions';

export function* setUserSaga() {
  try {
    const { data }: AxiosResponse<ApiResponse<any>> = yield call(
      getUserDetailsApi,
    );
    yield put(setUserData(data));
  } catch (err) {
    console.log(err);
  }
}

export function* getFranchiseByCode({ payload }: SagasAction<string>) {
  yield put(setErrorDraft(null));
  try {
    const { cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<any>> = yield call(
      getUserFranchiseByCodeApi,
      payload,
      cpId,
    );
    yield put(setFranchiseByCode(data.response));
  } catch (err: any) {
    yield put(setErrorDraft(err));
  }
}

export function* setBankListSaga() {
  try {
    const { cpId } = yield select(
      (state: ApplicationState) => state.storesContext,
    );
    const { stores } = yield select(
      (appState: ApplicationState) => appState.storesContext,
    );
    const { data }: AxiosResponse<ApiResponse<any>> = yield call(
      getBankListApi,
      cpId,
      stores[0].code,
    );
    yield put(setBankList(data));
  } catch (err) {
    console.log(err);
  }
}

function defineBodyDTO(
  state: OpenClaimState,
  currBody: any,
  indexCurrentStep: number,
) {
  const body = {
    ...currBody,
  };

  body.stepsArray = state.stepsArray;
  body.step = state.currentStep;
  if (state.destiny === 'forward') {
    body.step = state.stepsArray[indexCurrentStep + 1];
  }

  if (state.step.step1) {
    body.franchise = state.step.step1.lojas.data;
    body.subCoverage = state.step.step1.tipos.data;
  }
  if (state.step.step2) {
    body.occurrenceDescription = state.step.step2.occurrenceDescription;
    body.occurrenceDate = state.step.step2.occurrenceDate;
    let rightLoss;
    if (state.step.step2.estimateLoss) {
      const wrongLoss = state.step.step2?.estimateLoss
        .replace('R$', '')
        .replace(/\./g, '')
        .replace(/,/g, '');
      const len = wrongLoss.length;
      // eslint-disable-next-line prettier/prettier
      rightLoss = `${wrongLoss.substring(0, len - 2)}.${wrongLoss.substring(len - 2)}`;
    }
    body.estimatedLoss = rightLoss ? Number(rightLoss) : undefined;
  }
  if (state.step.step3) {
    body.comments = state.step.step3.comments;
    body.responsible = state.step.step3.accountable;
    body.email = state.step.step3.email;
    body.cellphone = state.step.step3.cellphone;
    body.telephone = state.step.step3.businessphone;
    if (state.step.step3.bank) {
      body.bank = {
        name: state.step.step3.bank.data?.NomeReduzido,
        code: state.step.step3.bank.data?.NumeroCodigo?.toString(),
        ispb: state.step.step3.bank.data?.ISPB?.toString(),
        agency: state.step.step3.agency,
        account: state.step.step3.account,
      };
    }
    body.confirmation = state.step.step3.confirmData;
  }
  if (state.step.step4) {
    body.declarationNE = {
      hasDeclaration: state.step.step4.state.declarationRadio,
      fileDeclarationId: '',
    };
  }

  return body;
}

export function* saveDraftSaga() {
  const getOpenClaim = (state: any) => state.openClaim;
  const state: OpenClaimState = yield select(getOpenClaim);

  const indexCurrentStep = state.stepsArray.findIndex(
    step => step === state.currentStep,
  );

  const body: any = defineBodyDTO(state, {}, indexCurrentStep);

  yield put(setErrorDraft(null));
  yield put(setSuccessDraft(null));
  const { cpId } = yield select(
    (appState: ApplicationState) => appState.storesContext,
  );
  try {
    if (!state.draftId) {
      const { data }: AxiosResponse<ApiResponse<any>> = yield call(
        createClaim,
        body,
        cpId,
        body.franchise.code,
      );
      yield put(setDraftId(data.response.id));
      yield put(setSuccessDraft(data));
    } else {
      const { data }: AxiosResponse<ApiResponse<any>> = yield call(
        updateClaim,
        body,
        state.draftId,
        cpId,
        body.franchise.code,
      );
      yield put(setSuccessDraft(data));
    }
    if (state.destiny === 'forward') {
      yield put(setCurrentStep(state.stepsArray[indexCurrentStep + 1]));
      yield put(
        setUnlockedSteps(
          state.unlockedSteps < state.stepsArray[indexCurrentStep + 1]
            ? state.currentStep + 1
            : state.unlockedSteps,
        ),
      );
    }
  } catch (err: any) {
    yield put(setErrorDraft(err));
  }
}

export function* recoverDraftSaga() {
  const getOpenClaim = (state: any) => state.openClaim;
  const state: OpenClaimState = yield select(getOpenClaim);
  let draft: any = INITIAL_STATE;
  if (state.draftId) {
    try {
      const { cpId } = yield select(
        (appState: ApplicationState) => appState.storesContext,
      );
      const { stores } = yield select(
        (appState: ApplicationState) => appState.storesContext,
      );
      const { data }: AxiosResponse<ApiResponse<any>> = yield call(
        getClaimById,
        state.draftId,
        cpId,
        stores[0]?.code,
      );
      const { response } = data;

      if (response) {
        draft = {
          step1: {
            lojas: {
              value: response.franchise.code,
              label: `${response.franchise.code} - ${response.franchise.name}`,
              data: response.franchise,
            },
            tipos: {
              value: response.subCoverage.id,
              label: response.subCoverage.name,
              data: { ...response.subCoverage },
            },
          },
          step2: {
            occurrenceDescription: response.occurrenceDescription,
            occurrenceDate: response.occurrenceDate,
            estimateLoss: response.estimatedLoss
              ? `R$ ${response.estimatedLoss.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })}`
              : undefined,
          },
          step3: {
            comments: response.comments,
            accountable: response.responsible,
            email: response.email,
            cellphone: response.cellphone,
            businessphone: response.telephone,
            agency: response.bank?.agency,
            account: response.bank?.account,
            bank: {
              value: response.bank?.ispb,
              label: `${response.bank?.code} - ${response.bank?.name}`,
              data: {
                ISPB: response.bank?.ispb,
                NomeReduzido: response.bank?.name,
                NumeroCodigo: response.bank?.code,
              },
            },
            confirmData: response.confirmation,
          },
          step4: {
            state: {
              declarationRadio: response.declarationNE?.hasDeclaration,
            },
            files: response.files || [],
          },
        };
      }
      const currentStep = response.step;
      yield put(setRecoverDraft(draft));
      yield put(setFinalId(data.response.number)); // para mostrar no processo
      if (response.status === STATUS_OBJ.Draft) {
        yield put(setUnlockedSteps(currentStep));
        yield put(setCurrentStep(currentStep));
        if (response.stepsArray) {
          yield put(setStepsArray(response.stepsArray));
        }
      } else {
        yield put(setStatus(response.status));
      }
    } catch (err: any) {
      console.log(err);
      yield put(setErrorDraft(err.response));
    }
  }
}

export function* finishDraftSaga() {
  const getOpenClaim = (state: any) => state.openClaim;
  const state: OpenClaimState = yield select(getOpenClaim);
  const body: any = {
    id: state.draftId,
  };
  const franchiseCode: any = {
    code: state.step.step1.lojas.value,
  };
  const { cpId } = yield select(
    (appState: ApplicationState) => appState.storesContext,
  );
  try {
    yield call(finishClaimById, body, cpId, franchiseCode.code);
  } catch (err) {
    console.log(err);
  }
}

export const mapErrorsDocument = (
  documents: ResponseFilesUploaded,
): FileUploaded[] => {
  const response: FileUploaded[] = [];

  documents.success.forEach(document => {
    response.push({
      error: false,
      ...document,
    });
  });

  documents.errors.forEach(document => {
    response.push({
      error: true,
      ...document,
    });
  });

  return response;
};

export function* uploadDocumentSaga({
  payload,
}: SagasAction<{ files: FilesCallback[]; id: string; response: any }>) {
  const mountedResponse = mapErrorsDocument(payload.response);
  yield put(setUploadFileAction(mountedResponse));
}

export function* deleteDocumentSaga({
  payload,
}: SagasAction<{ idFile: string; claimId: string }>) {
  const { cpId } = yield select(
    (state: ApplicationState) => state.storesContext,
  );
  const getOpenClaim = (state: any) => state.openClaim;
  const claim: OpenClaimState = yield select(getOpenClaim);
  const franchiseCode: any = {
    code: claim.step.step1.lojas.value,
  };

  try {
    yield call(
      deleteFile,
      payload.claimId,
      payload.idFile,
      cpId,
      franchiseCode.code,
    );
    const uploadedFiles = yield* appSelect<any>(
      state => state.openClaim.step.step4.files,
    );
    const newUploadedFiles = uploadedFiles.filter(
      (file: any) => file.id !== payload.idFile,
    );

    yield put(setDeleteFileAction(newUploadedFiles));
  } catch (err) {
    console.log(err);
  }
}

export default all([
  takeLatest(OPENCLAIM_TYPES.FINISH_DRAFT, finishDraftSaga),
  takeLatest(OPENCLAIM_TYPES.SET_DATA_STEP, saveDraftSaga),
  takeLatest(OPENCLAIM_TYPES.GET_USER_FRANCHISE, getFranchiseByCode),
  takeLatest(OPENCLAIM_TYPES.RECOVER_DRAFT, recoverDraftSaga),
  takeLatest(OPENCLAIM_TYPES.GET_USER_REQUEST, setUserSaga),
  takeLatest(OPENCLAIM_TYPES.GET_BANKLIST_REQUEST, setBankListSaga),
  takeLatest(OPENCLAIM_TYPES.UPLOAD_DOCUMENT, uploadDocumentSaga),
  takeLatest(OPENCLAIM_TYPES.DELETE_DOCUMENT, deleteDocumentSaga),
  // setUserSaga,
  // setCoverageListSaga,
  // setBankListSaga,
]);
